export const GENERIC_SPORTS_HEADER = ';header;';
export const GENERIC_SPORTS_COMPETITIONS = ';competitions-page;';

export const PRICE_UPDATE_WS_ACTION = 'price_update';
export const EVENT_OFF_WS_ACTION = 'event_off';
export const WS_IDENTIFICATION_NAME = 'SportGeneric/Event';

export const MOREGAMESEVENTS_SPORTS_BLACKLIST = ['motor-racing'];
